import { createTheme, Theme, ThemeOptions } from "@mui/material";

const themes: {
  [key: string]: ThemeOptions;
} = {
  // eurocard: {
  //   palette: {
  //     mode: 'light',
  //     secondary: {
  //       main: '#fff',
  //     },
  //   },
  // },
};

const getDefaultTheme = (mode: "light" | "dark"): ThemeOptions => ({
  palette: {
    mode,
    secondary: {
      main: mode === "dark" ? "#1b1b1b" : "#fff",
    },
  },
});
const dmd2DefaultTheme: ThemeOptions = {
  typography: {
    fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
  },
  components: {
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          gap: "0.5rem",
          "& .MuiFormControl-root": {
            display: "flex",
          },
          "& .MuiFormHelperText-root": {
            // order: -1,
            marginTop: "0.5rem",
            marginBottom: 0,
            marginLeft: 0,
            fontSize: "1rem",
            lineHeight: "1.4",
          },
          "& .MuiFormHelperText-root:not(.Mui-error)": {
            color: "rgba(117, 117, 117, 1)",
          },
        },
        label: {
          fontWeight: 600,
          lineHeight: "1.4",
        },
        asterisk: {
          display: "none",
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          borderColor: "rgba(217, 217, 217, 1)",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: "0.5rem",
          backgroundColor: "#fff",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          borderRadius: 0,
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          color: "rgba(179, 179, 179, 1)",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          textTransform: "none",
          fontSize: "1rem",
          fontWeight: 300,
        },
        contained: {
          backgroundColor: "rgba(44, 44, 44, 1)",
          "&:hover": {
            backgroundColor: "#000",
          },
          "&:focus-visible": {
            backgroundColor: "#000",
          },
        },
        text: {
          color: "rgba(48, 48, 48, 1)",
          "&:hover": {
            color: "#000",
          },
          "&:focus-visible": {
            color: "#000",
          },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          padding: "1.5rem 1.25rem 1.5rem 1.25rem",
          alignItems: "flex-start",
        },
        standard: {
          backgroundColor: "rgba(249, 250, 251, 1)",
          color: "rgba(30, 41, 57, 1)",
          borderRadius: "0.625rem",
          fontSize: "1rem",
          padding: "1rem",
          alignItems: "center",
        },
        standardWarning: {
          backgroundColor: "rgba(255, 251, 235, 1)",
          color: "rgba(30, 41, 57, 1)",
        },
        icon: {
          padding: 0,
          fontSize: 36,
          marginRight: "1.5rem",
          marginTop: 0,
        },
        message: {
          display: "flex",
          flexDirection: "column",
          gap: "0.25rem",
          padding: "0",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "0.5rem",
          lineHeight: 1,
        },
        input: {
          padding: "0.5625rem 1rem 0.5rem",
          lineHeight: 1,
        },
      },
    },
  },
};

export enum Websites {
  DISPUTE = "dispute",
  DMD2 = "dmd2",
}

export const getTheme = (
  brandStr: string,
  website = Websites.DISPUTE,
  mode: "light" | "dark" = "light",
): Theme => {
  const brandTheme = themes[brandStr] ?? {};

  if (website === Websites.DMD2) {
    const darkModeOverrides: ThemeOptions =
      mode === "dark"
        ? {
            components: {
              MuiPaper: {
                styleOverrides: {
                  root: {
                    backgroundColor: "#1f1f1f",
                  },
                },
              },
              MuiAlert: {
                styleOverrides: {
                  standard: {
                    backgroundColor: "#202020",
                    color: "#e4e4e4",
                  },
                  standardWarning: {
                    backgroundColor: "#3a2d12",
                    color: "#f5e6be",
                  },
                },
              },
              MuiButton: {
                styleOverrides: {
                  contained: {
                    backgroundColor: "#f0f0f0",
                    color: "#121212",
                    "&:hover": {
                      backgroundColor: "#ffffff",
                    },
                    "&:focus-visible": {
                      backgroundColor: "#ffffff",
                    },
                  },
                },
              },
              MuiFormControlLabel: {
                styleOverrides: {
                  root: {
                    "& .MuiFormHelperText-root:not(.Mui-error)": {
                      color: "rgba(214, 214, 214, 1)",
                    },
                  },
                },
              },
            },
          }
        : {};

    return createTheme(
      getDefaultTheme(mode),
      dmd2DefaultTheme,
      darkModeOverrides,
      brandTheme,
    );
  }
  return createTheme(getDefaultTheme(mode), brandTheme);
};
